import React, { useCallback } from 'react';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import classNames from 'classnames';
import { browserHistory } from 'react-router';
import { desktopOnly } from 'utils/UiHelper';
import {
    HorizontalNavigationWrapper,
    ScrollArea,
    NavListStyled,
} from './styled';
import { buildPathBySportItem, specialRoutes } from './helper';
import HorizontalNavigationItem from './HorizontalNavigationItem/HorizontalNavigationItem';
import { detectMobile } from '../../utils/UiHelper';

const HorizontalNavigation = ({
    items,
    clickHandler,
    selectedSport,
    selectedId,
    trackClickEvent,
    trackImpressionEvent,
    userId,
    sortedSportsIds,
    showWhiteItems,
}) => {
    const pathnameArr = window.location.pathname.split('/');
    const pathname = pathnameArr.slice(1);

    const onClickHandler = useCallback(
        (item) => {
            if (!specialRoutes.hasOwnProperty(item.id) && clickHandler) {
                clickHandler(item);
            } else {
                const newPath = buildPathBySportItem(item, pathname);
                browserHistory.push(newPath);
            }

            if (
                trackClickEvent &&
                window.location.pathname.includes('/live') &&
                sortedSportsIds?.includes(item.id)
            ) {
                const index = items.findIndex((el) => el.id === item.id);
                const position = index + 1;
                trackClickEvent(
                    'clicks:sport',
                    `sr:sport:${item.id}`,
                    'sport_id',
                    'sr:widget:livepagesport:recommended',
                    window.location.pathname,
                    userId || 0,
                    position
                );
            }
        },
        [
            clickHandler,
            trackClickEvent,
            sortedSportsIds,
            items,
            window.location.pathname,
            userId,
        ]
    );

    const navItems = selectedSport?.itemList || items || [];

    return (
        <HorizontalNavigationWrapper
            id="HorizontalNavigation"
            className={classNames('always-visible', {
                desktop: desktopOnly(),
            })}
        >
            <NavListStyled $isMobile={detectMobile()}>
                {navItems.map((item, index) => (
                    <HorizontalNavigationItem
                        key={item.name}
                        item={item}
                        selectedId={selectedId}
                        selectedSport={selectedSport}
                        onClickHandler={onClickHandler}
                        showWhiteItems={showWhiteItems}
                    />
                ))}
            </NavListStyled>
        </HorizontalNavigationWrapper>
    );
};

export default HorizontalNavigation;
